import React, { PropsWithChildren } from "react";

function StoreResults(props: PropsWithChildren<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      fill="none"
      viewBox="0 0 20 16"
      {...props}>
      <path
        fill="#522398"
        d="M3.121 4.5c0-.298.132-.585.366-.796.234-.21.551-.329.882-.329h3.746c.33 0 .648.119.882.33.235.21.366.497.366.795v1.125h1.248V4.5c0-.298.132-.585.366-.796.234-.21.552-.329.883-.329h3.745c.331 0 .649.119.883.33.234.21.366.497.366.795v1.125h1.872v-4.5c0-.298-.131-.585-.365-.795a1.321 1.321 0 00-.883-.33H2.497c-.331 0-.649.119-.883.33a1.072 1.072 0 00-.366.795v4.5h1.873V4.5zm14.357 2.25H2.497c-.662 0-1.297.237-1.766.659A2.143 2.143 0 000 9v6.188c0 .149.066.292.183.397a.66.66 0 00.441.165h.624a.66.66 0 00.442-.165.536.536 0 00.183-.398V13.5h16.23v1.688c0 .149.065.292.182.397a.66.66 0 00.441.165h.625a.66.66 0 00.44-.165.536.536 0 00.184-.398V9c0-.597-.263-1.169-.732-1.591a2.643 2.643 0 00-1.765-.659zm.624 5.063H1.872V9c0-.15.066-.292.183-.398a.66.66 0 01.442-.165h14.98a.66.66 0 01.442.165.536.536 0 01.183.398v2.813z"></path>
    </svg>
  );
}

export default React.memo(StoreResults);
